import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { useLocation } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import CtaLink from 'components/essentials/Cta/CtaLink';
import { logError } from 'commons/logger';
import PDPAlertBar from 'components/consumer/PDP/PDPAlertBar';
import { UPDATE_ORDER_AFFIRM_UPCHARGE } from 'mocks/mutations';
import { DL_UPCHARGE_PRODUCT_OPTIONS } from 'commons/constants';
import { getItemFromStorage, removeItemInStorage } from 'commons/localStorage';
import UpChargeSuccess from '../UpChargeSuccess/UpChargeSuccess';

const AffirmUpholsteryUpCharge = ({
  email,
  order_id,
  customer_id,
  cart_id,
  plan_id,
  plan_name,
  product_name,
  upholstery_name,
  checkout_token,
  payment_token,
  ctaStyles = null,
}) => {
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const location = useLocation();

  const [affirmUpCharge] = useMutation(UPDATE_ORDER_AFFIRM_UPCHARGE);

  useEffect(() => {
    (async () => {
      try {
        const productOptions = getItemFromStorage(DL_UPCHARGE_PRODUCT_OPTIONS);
        let res = await affirmUpCharge({
          variables: {
            input: {
              email,
              plan_id,
              cart_id,
              order_id,
              customer_id,
              payment_token,
              checkout_token,
              productOptions,
            },
          },
        });

        res = get(res, 'data.updateOrderAffirmUpCharge');
        const success = get(res, 'success', false);
        if (success) {
          setIsSuccess(true);
          removeItemInStorage(DL_UPCHARGE_PRODUCT_OPTIONS);
        } else {
          const message = get(res, 'errors.0.message', null);
          setError(message || 'Error occurred. Please try again.');
        }
      } catch (e) {
        logError(e);
      }
    })();
    // TODO: We need to investigate the exhaustive-deps issue here and will
    // need to ensure that adding all dependencies does not cause this to
    // re-run unnecessarily. We may need to check if this has already completed
    // before making the API call, or this may be a candidate for the useEvent
    // hook from React once it is available.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isSuccess) {
    return (
      <UpChargeSuccess
        planName={plan_name}
        productName={product_name}
        upholsteryName={upholstery_name}
      />
    );
  }

  return (
    <div className="min-h-[calc(100vh_-_200px)] text-center max-w-[400px] mx-auto my-0 p-4">
      {error ? (
        <PDPAlertBar type="error">
          <div>{error}</div>
          <CtaLink
            to={location.pathname}
            hasArrow={false}
            color="brand"
            className={ctaStyles}
          >
            Try again
          </CtaLink>
        </PDPAlertBar>
      ) : (
        <div className="text-base font-bold">Loading...</div>
      )}
    </div>
  );
};

AffirmUpholsteryUpCharge.propTypes = {
  email: PropTypes.string.isRequired,
  order_id: PropTypes.string.isRequired,
  customer_id: PropTypes.string.isRequired,
  product_name: PropTypes.string.isRequired,
  checkout_token: PropTypes.string.isRequired,
  payment_token: PropTypes.string,
  cart_id: PropTypes.string,
  plan_id: PropTypes.string,
  plan_name: PropTypes.string,
  upholstery_name: PropTypes.string,
  ctaStyles: PropTypes.string,
};

export default AffirmUpholsteryUpCharge;
